import { render, staticRenderFns } from "./DealPutUp.vue?vue&type=template&id=165c9d27&"
import script from "./DealPutUp.vue?vue&type=script&lang=ts&"
export * from "./DealPutUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports